import React from 'react';

export default function Director() {
  return (
    <section id="director" className="py-24 md:py-32 relative" style={{background:'#0F1629'}}>
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center relative reveal">
        {/* Big quote mark */}
        <div className="absolute -top-10 left-6 leading-none select-none pointer-events-none"
          style={{fontFamily:'Playfair Display,serif',fontSize:'18rem',color:'rgba(200,168,75,0.04)',lineHeight:1}}>
          "
        </div>

        <span className="section-tag">Director's Message</span>
        <h2 className="font-playfair font-black text-white mb-12" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(1.8rem,3vw,2.5rem)'}}>
          A Message to Our <span style={{color:'#C8A84B'}}>Students</span>
        </h2>

        {/* Director photo + quote */}
        <div className="grid md:grid-cols-3 gap-10 items-center text-left">
          <div className="md:col-span-1 flex flex-col items-center">
            <div className="w-40 h-40 rounded-full overflow-hidden mb-4" style={{border:'3px solid rgba(200,168,75,0.3)'}}>
              {/* <div className="img-placeholder w-full h-full">
                <div className="text-4xl">👨‍💼</div>
                <span style={{fontSize:'0.6rem'}}>Director Photo</span>
              </div> */}
                  <img src="/images/logos/director.jpg" className="w-full h-full object-contain" alt="ITS Academy Director" />
            </div>
            <div className="text-white font-bold">Director</div>
            <div style={{color:'#C8A84B',fontSize:'0.82rem'}}>ITS Academy Saharanpur</div>
            <div style={{color:'rgba(212,207,197,0.4)',fontSize:'0.72rem',marginTop:'4px'}}>Est. 2001</div>
          </div>

          <div className="md:col-span-2 relative z-10 space-y-5">
            {[
              '"At ITS Academy, we see every student as a future leader, innovator, and professional. Our goal is not just to teach computer skills but to ignite curiosity, build confidence, and cultivate excellence."',
              '"Here, you are encouraged to dream big, embrace challenges, and transform knowledge into action. Every lesson, every practice session, and every project is a step towards your brighter future."',
              '"Your learning today is the foundation of your success tomorrow. So, stay curious, stay committed, and believe in yourself — because at ITS Academy, we believe in you."',
            ].map((quote, i) => (
              <p key={i} className="leading-relaxed"
                style={{color: i === 2 ? 'rgba(240,208,128,0.9)' : 'rgba(212,207,197,0.75)',fontSize:'0.95rem',fontStyle:'italic',lineHeight:'1.9'}}>
                {quote}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
